import {SubAPI} from "./SubAPI";
import {Paginated} from "./Users";
import {DateString} from "./Projects";

export class Receivables extends SubAPI {

    list(props: {
        project?: number;
        search?: string;
        status?: "paid" | "draft" | "needs-quickbooks-sync" | "pending-approval";
        offset?: number;
    }) {
        return this.fetcher.get<Paginated<Receivable>>("/api/receivables", props);
    }

    get(props: {id: number}) {
        return this.fetcher.get<Receivable>("/api/receivable", props);
    }

    upsert(input: Partial<Receivable> & {
        importPos?: number[];
    }) {
        return this.fetcher.post<Receivable>("/api/receivable", input);
    }

    listItems(props: {
        offset?: number;
        receivable: number;
    }) {
        return this.fetcher.get<Paginated<ReceivableItem>>("/api/receivable/items", props);
    }

    upsertItem(input: Partial<ReceivableItem>) {
        return this.fetcher.post<ReceivableItem>("/api/receivable/item", input);
    }

    removeAttachment(input: {
        receivable: number;
        file: number;
    }) {
        return this.fetcher.post("/api/receivable/remove-attachment", input);
    }

    uploadAttachment(input: {
        id: number;
        file: File;
    }) {
        return this.fetcher.postFormData("/api/receivable/upload-attachment", {
            id: input.id.toString(),
            file: input.file,
        })
    }
    
    approve(input: {
        receivable: number;
        approved: boolean;
    }) {
        return this.fetcher.post("/api/receivable/approve", input);
    }
    
    quickbooksSync(input: {
        receivable: number;
    }) {
        return this.fetcher.post("/api/receivable/quickbooks-sync", input)
    }
}

export type Receivable = {
    id: number;

    customer: number;
    invoiceNumber: string;
    customerName: string;

    invoiceDate: string;
    dueDate: string | null;

    project: number;
    projectName: string;
    projectNumber: number;

    status: string;

    archived: boolean;
    totalCents: number;

    createdAt: DateString;
    updatedAt: DateString;
    updatedBy: number;

    approvedBy: number | null;
    approvedByName: string | null;
    approvedAt: DateString | null;

    projectProgressBillingNumber: string;
    projectProgressLastBillDate: string | null;
    includedInSovBilled: boolean;

    nextProjectReceivable: number | null;
    nextProjectReceivableInvoiceNumber: string | null;

    progressStatement: number | null;
    progressStatementName: number | null;

    projectSovHeadingItemMeta: {[k: number]: number} | null; // sovHeadingItemId => amountCents

    quickbooksSyncComplete: boolean;

    attachments: {
        id: number;
        name: string;
    }[];
}

export type ReceivableItem = {
    id: number;
    receivable: number;

    projectSovChange: number | null;
    projectSovChangeName: string | null;
    projectSovHeading: number | null;
    projectSovHeadingName: string | null;
    projectSovHeadingItem: number | null;
    projectSovHeadingItemName: string | null;
    projectSovCanBill?: number | null;
    projectSovContractRemaining?: number | null;

    description: string;
    qty: number;
    unitAmountCents: number;
    archived: boolean;
    createdAt: DateString;
    updatedAt: DateString;
    updatedBy: number;
}